module.exports = "<router-outlet></router-outlet>\n<ngx-loading class=\"fixed-loader\" [show]=\"loading\"></ngx-loading>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main